/**
 * Merge deep objects
 * @return {*}
 */
function deepExtend() {
  const args = Array.prototype.slice.call(arguments);
  let a = args.shift();

  for (let i = 0; i < args.length; i += 1) {
    const b = args[i];

    if (a !== null && b !== null && typeof a !== 'undefined' && typeof b !== 'undefined') {
      // Merge objects
      if (typeof a === 'object' && typeof b === 'object') {
        // Merge arrays
        if (a instanceof Array && b instanceof Array) {
          for (let index = 0; index < b.length; index += 1) {
            if (typeof b[index] !== 'undefined') {
              if (b[index] !== null && typeof b[index] === 'object') {
                a[index] = deepExtend(a[index], b[index]);
              } else {
                a[index] = b[index];
              }
            }
          }
        } else {
          const keys = Object.keys(b);

          for (let j = 0; j < keys.length; j += 1) {
            const key = keys[j];

            if (typeof b[key] === 'object' && b[key] !== null) {
              a[key] = deepExtend(a[key], b[key]);
            } else if (typeof b[key] !== 'undefined') {
              a[key] = b[key];
            }
          }
        }
      }
    } else if (b !== null && typeof b !== 'undefined') {
      a = b;
    }
  }
  return a;
}

module.exports = deepExtend;
